import { t } from "i18next";
import { IconType } from "../iconTypes";
import Icon from "components/atoms/icon/Icon";
import { useDeleteQualityQuestion } from "lib/hooks/mutations/Settings/useDeleteQualityQuestion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import IconButton from "components/atoms/button/IconButton";

export const qualityManagementHeaders = [
    {
        id: 1,
        Header: "Creation Date",
        accessor: (row: any) => new Date(row?.created_at),
        Cell: ({ row }: any) => {
            return (
                <div>
                    {new Date(row.original.created_at).toLocaleDateString('de')}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 2,
        Header: "Question",
        accessor: "question_text",
        isChecked: true
    },
    {
        id: 3,
        Header: "Question Type",
        accessor: "question_type",
        isChecked: true
    },
    {
        id: 4,
        Header: "Description",
        accessor: "description",
        isChecked: true
    },
    {
        id: 5,
        Header: "Required",
        accessor: "is_required",
        Cell: ({ row }: any) => {
            return (
                <div>{row.original.is_required === 1 ? t("Yes") : t("No")}</div>
            );
        },
        isChecked: true
    },
    {
      Header: "",
      accessor: "actions",
      id: 6,
      Cell: ({ row }: any) => (
        <DeleteQualityQuestionButton id={row.original.id} />
      ),
      isChecked: true,
    },
];

const DeleteQualityQuestionButton = ({ id } : any) => {
    const { mutate: deleteQuestion, isLoading } = useDeleteQualityQuestion();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const { t } = useTranslation();

    const handleDelete = () => {
        if (isLoading) return;
        deleteQuestion(id);
        setShowConfirmModal(false);
    };

    return (
        <>
            <div
                className="cursor-pointer"
                onClick={() => {
                    if (!isLoading) {
                        setShowConfirmModal(true);
                    }
                }}
            >
                <Icon iconType={IconType.DELETE_ICON} color="#282D46" />
            </div>

            {showConfirmModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-[--theme] opacity-[0.16] z-10"></div>
                    <div className="bg-white rounded-xl p-6 w-[90%] max-w-md shadow-xl relative z-50">
                        <h3 className="text-lg font-semibold mb-4">{t('Confirm Action')}</h3>
                        <p className="mb-6">{t('Are you sure you want to delete this question')}?</p>
                        <div className="flex justify-end gap-4">
                            <IconButton
                                onClick={() => setShowConfirmModal(false)}
                                secondary={true}
                                type="button"
                                className="w-full max-w-[150px]"
                            >
                                {t('Back')}
                            </IconButton>
                            <IconButton
                                onClick={handleDelete}
                                type="submit"
                                className="w-full max-w-[150px]"
                            >
                                {isLoading ? t('Deleting...') : t('Confirm')}
                            </IconButton>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

